import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    employees: [],
    mandanten: [],
    loadingEmployees: false,
    loadingMandanten: false,
    creating: false,
    modalOpen: false,
    errorMessage: null,
};

const userManagementSlice = createSlice({
    name: "userManagement",
    initialState,
    reducers: {
        getEmployeesRequest: (state) => {
            state.loadingEmployees = true;
            state.errorMessage = null;
        },
        getEmployeesSuccess: (state, action) => {
            state.loadingEmployees = false;
            state.employees = action.payload || [];
        },
        getEmployeesFailure: (state, action) => {
            state.loadingEmployees = false;
            state.errorMessage = action.payload;
        },

        getMandantenRequest: (state) => {
            state.loadingMandanten = true;
        },
        getMandantenSuccess: (state, action) => {
            state.loadingMandanten = false;
            state.mandanten = action.payload || [];
        },
        getMandantenFailure: (state, action) => {
            state.loadingMandanten = false;
            state.errorMessage = action.payload;
        },

        createEmployeeRequest: (state) => {
            state.creating = true;
            state.errorMessage = null;
        },
        createEmployeeSuccess: (state) => {
            state.creating = false;
        },
        createEmployeeFailure: (state, action) => {
            state.creating = false;
            state.errorMessage = action.payload;
        },

        toggleModal: (state, action) => {
            state.modalOpen = action.payload !== undefined ? action.payload : !state.modalOpen;
            state.errorMessage = null;
        },
        clearError: (state) => {
            state.errorMessage = null;
        },
    },
});

export default userManagementSlice;
